import Roof from '../roofs/roof.js'
import isNumber from 'is-number'
let text = window.text; // We depend on global localization

export default class HalfHippedUtstick extends Roof {
  constructor(r,p) {
    super(r,p)

    this.inputs = [
      {
        name: "length",
        title: text.length
      },
      {
        name: "width",
        title: text.width
      },
      {
        name: "height",
        title: text.height,
        alternatives:{
          names: ["angle"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "height"){
              return height;
            }
            return Roof.angle(height,values["width"])*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "height"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return Roof.angleToHeight(values["width"], angle);
          },
        },
      },
      {
        // This is now changed to be length of botom of the utstikk,
        // before the triangle part starts
        // TODO:Change name and texts. Suggested new new is lbottom 
        name: "attachl",
        title: text.lattach
      },
      {
        name: "endw",
        title: text.wend
      },
      {
        name: "endl",
        title: text.lend
      },
      {
        name: "spacefoot",
        title: text.spacefoot,
        validate: (val) => {
          if (val) {
            return isNumber(val)
          }
          return true
        }
      },
    ]

    this.name = text.uHalf
    this.description = text.udHalf
  }

  subarea() {
    let p = this.props
    return p.width*Math.sqrt(p.height*p.height+p.endl*p.endl)/2
  }

	pipes() {
		let i = this.props
    const spaceFoot = i.spacefoot > 0 ? [-i.width] : []
    return [i.length-i.endl, i.length-i.endl, i.endw, , ...spaceFoot]
	}

  vindski() {
    let arad = this.angle()
    let w = this.props.width/2;
    let w1 = (w-this.props.endw/2)/Math.cos(arad)
    return 2*w1;
  }

  gradeGutter() {
    const skraKant = Math.sqrt(Math.pow(this.props.width/2.0,2.0) + Math.pow(this.props.height,2.0))
    const oneKant = Math.sqrt(Math.pow(skraKant,2.0) + Math.pow(this.props.length-this.props.attachl,2.0));
    return 2 * oneKant;
  }

  mone() {
    let arad = this.angle()
    let w = this.props.width/2;
    let height = w*Math.tan(arad);
    let w1 = (w-this.props.endw/2)/Math.cos(arad)
    let l1 = (this.props.endl)
    let heightlower = w1*Math.sin(arad)
    let hu = height-heightlower
    let l1a = Math.sqrt(l1*l1 + hu*hu)
    let diag = Math.sqrt(this.props.endw*this.props.endw + l1a*l1a)

    let top = this.props.length - this.props.endl;
    return top + 2*diag;
  }

  validateInput(inputs){
    if (inputs == undefined){
      return undefined;
    }
    let ret = {}
    let hasError = false;
    if (inputs.endl > inputs.length){
      ret["endl"] = text.errLengthEndUtstick
      hasError = true 
    }
    if (inputs.endw > inputs.width){
      ret["endw"] = text.errWidthEnd
      hasError = true 
    }
    if (inputs.attachl > inputs.length){
      ret["attachl"] = text.errDontFit
      hasError = true 
    }

    if(hasError){
      return ret;
    }
    return undefined;
  }

  angle(){
    return Math.atan2(this.props.height,this.props.width/2)
    //return Math.PI*this.props.angle/180
  }

  topatches() {
    let arad = this.angle()
    let w = this.props.width/2;

    let height = w*Math.tan(arad)*1000;
    let w1 = 1000*(w-this.props.endw/2)/Math.cos(arad)
    let w2 = 1000*w/Math.cos(arad)
    let l1 = 1000*(this.props.endl)
    let heightlower = w1*Math.sin(arad)
    let hu = height-heightlower

    let l1a = Math.sqrt(l1*l1 + hu*hu)
    let attachLength = this.props.length - this.props.attachl
    let lengthBottom = this.props.attachl
    let patches = [
      this.fromarr(
        attachLength*1000,0,
        0,w2,
        1000*this.props.length-l1, w2,
        1000*this.props.length, w1,
        1000*(this.props.length),0
      ),
      this.fromarr(
        0,0,
        0,w1,
        l1, w2,
        1000*this.props.length, w2,
        1000*(lengthBottom),0
      ),
      this.fromtriangle(1000*this.props.endw,l1a ),
    ];
    return patches;
  }

  patchtransforms() {
    let arad = this.angle()
    let w = this.props.width/2;

    let height = w*Math.tan(arad)*1000;
    let w1 = 1000*(w-this.props.endw/2)/Math.cos(arad)
    let w2 = 1000*w/Math.cos(arad)
    let l1 = 1000*(this.props.endl)
    let heightlower = w1*Math.sin(arad)
    let hu = height-heightlower

    let l1a = Math.sqrt(l1*l1 + hu*hu)

    let off = w2/20
    return [
      {
        t: [-1000*this.props.length/2, -w2-off],
        r: [0, 0, 0],
      },
      {
        t: [-1000*this.props.length/2, -w2-off],
        r: [180, 0, 0],
      },
      {
        t: [-500*this.props.endw+500*this.props.length-l1, -l1a-off],
        r: [90, +500*this.props.length-l1, 0],
      },
    ];
  }

}



// WEBPACK FOOTER //
// ./utsticks/halfhippedutstick.js